export const CURRENT_DICTIONARY_PATH = "/dictionaries/:dictionary";
